(() => {
  const initialized = new WeakSet();

  function moneyFormatter(currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 2,
      });
    } catch (_error) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
  }

  function wholeMoneyFormatter(currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'USD',
        maximumFractionDigits: 0,
      });
    } catch (_error) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    }
  }

  function formatCents(formatter, cents) {
    return formatter.format(Number(cents || 0) / 100);
  }

  function initialize(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const sectionId = root.dataset.section;
    const packSelector = root.querySelector('[data-silverlight-pack-selector]');
    const stickyBar = root.querySelector('[data-silverlight-sticky-atc]');
    const stickyButton = root.querySelector('[data-silverlight-sticky-submit]');
    const mainSubmit = root.querySelector(`#ProductSubmitButton-${CSS.escape(sectionId)}`);
    const colorOption = root.querySelector('[data-silverlight-color-option]');
    const selectedColor = colorOption?.querySelector('[data-silverlight-selected-color]');
    let selectedQuantity = packSelector?.querySelector('input[name="quantity"]:checked')?.value;

    const selectPack = (input) => {
      if (!input) return;
      selectedQuantity = input.value;
      packSelector.querySelectorAll('.silverlight-pack-card').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(input));
      });
    };

    packSelector?.addEventListener('change', (event) => {
      if (event.target.matches('input[name="quantity"]')) selectPack(event.target);
    });

    colorOption?.addEventListener('change', (event) => {
      if (selectedColor && event.target.matches('input[type="radio"]')) {
        selectedColor.textContent = event.target.value;
      }
    });

    stickyButton?.addEventListener('click', () => {
      const form = document.getElementById(stickyButton.dataset.formId);
      form?.requestSubmit();
    });

    if (stickyBar && mainSubmit && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          stickyBar.hidden = entry.isIntersecting || window.scrollY < 300;
        },
        { threshold: 0.15 }
      );
      observer.observe(mainSubmit);
    }

    const updateVariant = (variant) => {
      if (!variant) return;
      const formatter = moneyFormatter(packSelector?.dataset.currency);
      const displayFormatter = packSelector?.dataset.roundPrices === 'true'
        ? wholeMoneyFormatter(packSelector?.dataset.currency)
        : formatter;
      const unitLabel = packSelector?.dataset.unitLabel || 'pair';
      const discountedTotal = (element) => {
        const quantity = Number(element.dataset.totalQuantity);
        const discount = Number(element.dataset.discountPercent || 0);
        if (discount > 0) {
          const discountedCents = (variant.price * quantity * (100 - discount)) / 100;
          return Math.round(discountedCents / 100) * 100;
        }
        return variant.price * Number(element.dataset.paidQuantity);
      };
      packSelector?.querySelectorAll('[data-pack-each]').forEach((element) => {
        const total = Number(element.dataset.totalQuantity);
        const rawEachCents = discountedTotal(element) / total;
        const eachCents = packSelector?.dataset.floorUnitPrice === 'true'
          ? Math.floor(rawEachCents)
          : rawEachCents;
        element.textContent = `${formatCents(displayFormatter, packSelector?.dataset.roundPrices === 'true' ? Math.round(eachCents / 100) * 100 : eachCents)}/${unitLabel}`;
      });
      packSelector?.querySelectorAll('[data-pack-compare]').forEach((element) => {
        element.textContent = formatCents(displayFormatter, variant.price * Number(element.dataset.totalQuantity));
      });
      packSelector?.querySelectorAll('[data-pack-total]').forEach((element) => {
        element.textContent = formatCents(displayFormatter, discountedTotal(element));
      });

      if (selectedQuantity && packSelector) {
        const selected = Array.from(packSelector.querySelectorAll('input[name="quantity"]')).find(
          (input) => input.value === selectedQuantity
        );
        if (selected) {
          selected.checked = true;
          selectPack(selected);
        }
      }

      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.querySelector('span').textContent = variant.available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) === String(sectionId)) updateVariant(data.variant);
      });
    }
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('product-info.silverlight-product-main').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
